
import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/NavBar.vue";
import InitialForm from "@/components/Initial/InitialForm.vue";
import BadFit from "@/components/Initial/BadFit.vue";
import ResponseModal from "@/components/Initial/ResponseModal.vue";
import { CreationResponse } from "../Models/CreationResponse";
import Loading from "@/components/Loading.vue";
import axios from "axios";
import { apiURL } from "@/App.vue";
import Banner from "@/components/Banner.vue";
import { Branding } from "@/helper";
import SplitContent from "@/components/SplitContent.vue";
import { InitialSetup } from "@/Models/InitialData";
import { getCurrentSignupFlow, SignupFlow } from "@/Models/SignupData";

@Component({
  components: {
    NavBar,
    InitialForm,
    BadFit,
    ResponseModal,
    Loading,
    Banner,
    SplitContent,
  },
})
export default class Initial extends Vue {
  public showBadFit: boolean = false;
  public response: CreationResponse | null = null;
  public showLoading: boolean = false;
  public initialDataLoading: boolean = true;
  public freeTrialDays: number | null = null;
  public initialSetupData: InitialSetup | null = null;

  public async created() {
    axios
      .get<InitialSetup>(apiURL() + "/api/Signup/InitialSetup")
      .then((response) => {
        this.initialSetupData = response.data;
        this.freeTrialDays = this.initialSetupData.FreeTrialDays;
      })
      .catch(() => {
        this.setResponse({
          Type: "GeneralError",
        } as CreationResponse);
      })
      .finally(() => {
        this.initialDataLoading = false;
      });
  }

  public get branding() {
    return Branding.getBranding();
  }

  public get splashImage() {
    return Branding.getCurrentBrand().initialSplash;
  }

  public get isSplitContent() {
    if (this.initialSetupData) {
      return (
        this.initialSetupData.CurrentSignupFlow === SignupFlow.AccessIdentity ||
        getCurrentSignupFlow(this.$route) === SignupFlow.AccessIdentity
      );
    }
    return false;
  }

  public toggleBadFit() {
    this.showBadFit = !this.showBadFit;
    window["grecaptcha"].reset();
  }

  public setResponse(response: CreationResponse) {
    this.response = response;
  }

  public setFreeTrialDays(days: number) {
    this.freeTrialDays = days;
  }

  public resendEmail() {
    this.showLoading = true;
    axios
      .get(apiURL() + "/api/Signup/ResendVerificationEmail", {
        params: {
          email: this.response!.EmailAddress,
        },
      })
      .then((response) => {
        this.showLoading = false;
        this.response = response.data;
      })
      .catch((error) => {
        this.showLoading = false;
        this.response = {
          Type: "GeneralError",
        } as CreationResponse;
      });
  }
}
